<template>
  <img src="../../../assets/img/avatars/avatar4.jpg" alt="avatar4">
</template>
